module.exports = __webpack_public_path__ + "static/img/game-NBA2K18.f027163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-NBA2K18.jpg
// module id = lNX6
// module chunks = 0